module.exports = __webpack_public_path__ + "media/images/lb/377-fa3934ff9490586ea912aae5c98f0718.svg";